import { isObject } from 'underscore';

import { Speaker } from '@/types/speakers.types';
import { IncorrectTypeError } from './incorrect-type-error';

export function assertIsSpeaker(speaker: unknown): asserts speaker is Speaker {
  if (!isObject(speaker)) {
    throw new IncorrectTypeError(`Object required, received ${JSON.stringify(speaker)}`);
  }
  if (!speaker.speaker || isNaN(speaker.speaker)) {
    throw new IncorrectTypeError(`Speaker ID number required, received ${JSON.stringify(speaker.speaker)}`);
  }
  if (!speaker.first_name || typeof speaker.first_name !== 'string') {
    throw new IncorrectTypeError(`Speaker first_name required, received ${JSON.stringify(speaker.first_name)}`);
  }
  if (!speaker.last_name || typeof speaker.last_name !== 'string') {
    throw new IncorrectTypeError(`Speaker last_name required, received ${JSON.stringify(speaker.last_name)}`);
  }
  if (!speaker.description || !isObject(speaker.description) || !('base' in speaker.description)) {
    throw new IncorrectTypeError(`Speaker description required, received ${JSON.stringify(speaker.description)}`);
  }
  if (!speaker.image || typeof speaker.image !== 'string') {
    throw new IncorrectTypeError(`Speaker image required, received ${JSON.stringify(speaker.image)}`);
  }
  if (typeof speaker.link_social !== 'boolean') {
    throw new IncorrectTypeError(`Speaker link_social required, received ${JSON.stringify(speaker.link_social)}`);
  }
}
